module.exports = __webpack_public_path__ + "static/media/review_1.3cbe1e88.png";